import { createSlice, current } from '@reduxjs/toolkit'

const initState = {
    data: [],
    oldData: [],
    client: null,
    userId: null,
    numClient: 1,
    code: "",
    subTotal: 0,
    vat: 0,
    grandTotal: 0,
    grandTotalRiel: 0,
    isNativeName: false,
    isStorePromotion: false,
    isPromotion: false,
    promotionType: 'none',
    useCode: false,
    totalDiscount: 0,
    totalDiscountStatus: false, // true = "%", false = "$"
    receiptId: null,
}

const orderList = createSlice({
    name: 'orderList',
    initialState: initState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        clearData: (state, action) => {
            return state = initState
        },
        clearClient: (state, action) => {
            state.client = null
            state.userId = null
        },
        changeNumClient: (state, action) => {
            const { val } = action.payload
            state.numClient = val
        },
        changeClient: (state, action) => {
            const { client } = action.payload
            state.client = client
        },
        changePreSale: (state, action) => {
            const { userId } = action.payload
            state.userId = userId
        },
        changePromoCode: (state, action) => {
            const { code } = action.payload
            state.code = code
        },
        retrieveItem: (state, action) => {
            const { record } = action.payload
            console.log("record: ", record)
            state.data = record.newRecord
            // state.vat = record.vat
            state.subTotal = record.subtotal
            state.grandTotal = record.totalPay
            state.grandTotalRiel = record.totalPayRiel
            state.numClient = record.numClient
            if (record.preSaleId === null || record.preSaleId === undefined) {
                state.userId = null
            } else {
                state.userId = {
                    username: record.preSaleName,
                    _id: record.preSaleId,
                    identity: record.preSaleIdentity,
                    firstName: record.preSaleFirstName,
                    lastName: record.preSaleLastName
                }
            }
            if (record.customerId === null || record.customerId === undefined) {
                state.client = null
            } else {
                state.client = {
                    ...record.customerData,
                    // fullName: record.customerName,
                    firstName: record.customerData.firstName,
                    lastName: record.customerData.lastName,
                    identity: record.customerIdentity
                }
            }
            // state.client = {
            //     ...record.customerData,
            //     fullName: record.customerName,
            //     identity: record.customerIdentity
            // }
        },
        addProduct: (state, action) => {
            console.log("action.payload: ", action.payload)
            const { findIndex, item, isPromotion, code } = action.payload
            if (findIndex === -1) {
                state.data.push({
                    ...item.newRecord[0],
                    qty: 1,
                    price: item.newRecord[0].pricing[0].startPrice,
                    total: item.newRecord[0].pricing[0].startPrice,
                    prefix: true,
                    discount: 0,
                    remark: "",
                    cancelRemark: ""
                })
            } else {
                state.data[findIndex].qty += 1
                state.data[findIndex].total = state.data[findIndex].qty * state.data[findIndex].price 

                if (!isPromotion) {
                    if (state.data[findIndex].prefix) {
                        let dis = state.data[findIndex].price * state.data[findIndex].discount / 100 * state.data[findIndex].qty
                        state.data[findIndex].total = state.data[findIndex].total - dis
                    } else {
                        state.data[findIndex].total = state.data[findIndex].total - state.data[findIndex].discount
                    }
                }
            }

            // if (isPromotion) {
            //     console.log("have!!!")
            //     dispatch(checkPromo({code: code}))
            // }
        },
        removeProduct: (state, action) => {
            const { index, isPromotion, code } = action.payload
            state.data.splice(index, 1)
            // if (isPromotion) {
            //     checkPromo({code: code})
            // }
        },
        changeQty: (state, action) => {
            const { option, index, isPromotion, code } = action.payload
            if (option === 'increase') {
                state.data[index].qty += 1
                state.data[index].total = state.data[index].qty * state.data[index].price
            } else {
                if (state.data[index].qty > 0) {
                    state.data[index].qty -= 1
                    state.data[index].total = state.data[index].qty * state.data[index].price
                }
            }

            if (!isPromotion) {
                if (state.data[index].prefix) {
                    let dis = state.data[index].price * state.data[index].discount / 100 * state.data[index].qty
                    state.data[index].total = state.data[index].total - dis
                } else {
                    state.data[index].total = state.data[index].total - state.data[index].discount
                }
            }
        },
        changeDiscount: (state, action) => {
            const { val, index } = action.payload
            state.data[index].discount = val
            state.data[index].total = state.data[index].qty * state.data[index].price
            if (state.data[index].prefix) {
                let dis = state.data[index].price * val / 100 * state.data[index].qty
                // state.data[index].discount = dis
                state.data[index].total = state.data[index].total - dis
            } else {
                state.data[index].total = state.data[index].total - val
            }
        },
        changeDiscountPrefix: (state, action) => {
            const { index } = action.payload
            state.data[index].prefix = !state.data[index].prefix
            state.data[index].discount = 0
            state.data[index].total = state.data[index].qty * state.data[index].price
        },
        changeRemark: (state, action) => {
            const { val, index } = action.payload
            state.data[index].remark = val
        },
        checkPromo: (state, action) => {
            const { code } = action.payload
            console.log("code: ", code)
            let array = state.data.filter(x => x.Promotion !== null && x.isFinish === true)
            console.log("array.length: ", array)

            let result = array.reduce(function (r, a) {
                r[a[`Promotion`]._id] = r[a[`Promotion`]._id] || [];
                r[a[`Promotion`]._id].push(a);
                return r;
            }, Object.create(null))

            console.log("result: ", Object.values(result))

            if (array.length > 0) {
                Object.values(result).map((promo, index) => {
                    let priceLimit = promo[0][`Promotion`].priceLimit
                    let type = promo[0][`Promotion`].type
                    let cashType = promo[0][`Promotion`].cashType
                    let disAmount
                    let total = { subTotal: 0 }
                    promo.reduce((acc, o) => {
                        acc.subTotal += (o.qty * o.price)
                        return acc
                    }, total)
                    let isPriceLimit = total.subTotal >= priceLimit ? true : false
                    console.log(`index: `, index)

                    if (isPriceLimit) {
                        if (type === 'Discount') {
                            state.promotionType = promo[0][`Promotion`].type
                            state.isPromotion = true
                            state.code = ''
                            state.useCode = false
                            if (cashType === 'USD') {
                                disAmount = promo[0][`Promotion`].amount / total.subTotal * 100
                            } else {
                                disAmount = promo[0][`Promotion`].amount
                            }
                            promo.map(res => {
                                let index
                                if (res.variants.length > 0) {
                                    index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
                                } else {
                                    index = state.data.findIndex(e => e.productId === res.productId)
                                }
                                state.data[index].discount = promo[0][`Promotion`].amount
                                state.data[index].prefix = cashType === 'USD' ? false : true
                                let discount = state.data[index].price * state.data[index].qty * disAmount / 100
                                state.data[index].total = state.data[index].price * state.data[index].qty - discount
    
                                if (cashType === 'USD') {
                                    state.data[index].discount = discount
                                }
                            })
                        } else if (type === 'Coupon') {
                            let promCode = promo[0][`Promotion`].couponCode
                            if (code === promCode) {
                                state.promotionType = promo[0][`Promotion`].type
                                state.isPromotion = true
                                state.code = code
                                state.useCode = true
                                if (cashType === 'USD') {
                                    disAmount = promo[0][`Promotion`].amount / total.subTotal * 100
                                } else {
                                    disAmount = promo[0][`Promotion`].amount
                                }
                                promo.map(res => {
                                    let index
                                    if (res.variants.length > 0) {
                                        index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
                                    } else {
                                        index = state.data.findIndex(e => e.productId === res.productId)
                                    }
                                    state.data[index].discount = promo[0][`Promotion`].amount
                                    state.data[index].prefix = cashType === 'USD' ? false : true
                                    let discount = state.data[index].price * state.data[index].qty * disAmount / 100
                                    state.data[index].total = state.data[index].price * state.data[index].qty - discount

                                    if (cashType === 'USD') {
                                        state.data[index].discount = discount
                                    }
                                })
                            } else {
                                state.code = code
                                state.useCode = false
                                promo.map(res => {
                                    let index
                                    if (res.variants.length > 0) {
                                        index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
                                    } else {
                                        index = state.data.findIndex(e => e.productId === res.productId)
                                    }
                                    state.data[index].discount = 0
                                    state.data[index].total = state.data[index].qty * state.data[index].price
                                })
                            }
                        } else if (type === 'Gift Card') {
                            let promCode = promo[0][`Promotion`].codeName
                            if (code === promCode) {
                                state.promotionType = promo[0][`Promotion`].type
                                state.isPromotion = true
                                state.code = code
                                state.useCode = true
                                if (cashType === 'USD') {
                                    disAmount = promo[0][`Promotion`].amount / total.subTotal * 100
                                    console.log("disAmount: ", disAmount)
                                } else {
                                    disAmount = promo[0][`Promotion`].amount
                                }
                                promo.map(res => {
                                    let index
                                    if (res.variants.length > 0) {
                                        index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
                                    } else {
                                        index = state.data.findIndex(e => e.productId === res.productId)
                                    }
                                    state.data[index].discount = promo[0][`Promotion`].amount
                                    state.data[index].prefix = cashType === 'USD' ? false : true
                                    let discount = state.data[index].price * state.data[index].qty * disAmount / 100
                                    state.data[index].total = state.data[index].price * state.data[index].qty - discount

                                    if (cashType === 'USD') {
                                        state.data[index].discount = discount
                                    }
                                })
                            } else {
                                state.code = code
                                state.useCode = false
                                promo.map(res => {
                                    let index
                                    if (res.variants.length > 0) {
                                        index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
                                    } else {
                                        index = state.data.findIndex(e => e.productId === res.productId)
                                    }
                                    state.data[index].discount = 0
                                    state.data[index].total = state.data[index].qty * state.data[index].price
                                })
                            }
                        }
                    }
                })
            }

            // if (array.length > 0) {
            //     // result = 
            //     // array.map(res => {
            //     //     let disAmount
            //     //     let total = { subTotal: 0 }
            //     //     let newArr = array.filter(x => x[`Promotion`]._id === res[`Promotion`]._id)
            //     //     newArr.reduce((acc, o) => {
            //     //         acc.subTotal += (o.qty * o.price)
            //     //         return acc
            //     //     }, total)
            //     //     let isPriceLimit = total.subTotal >= res[`Promotion`].priceLimit ? true : false

            //     //     if (isPriceLimit) {
            //     //         if (res[`Promotion`].type === 'Discount') {

            //     //         } else if (res[`Promotion`].type === 'Coupon') {
                            
            //     //         } if (res[`Promotion`].type === 'Gift Card') {
                            
            //     //         }
            //     //     } else {

            //     //     }
            //     // })


            //     // state.isPromotion = true
            //     let priceLimit = array[0][`Promotion`].priceLimit
            //     let type = array[0][`Promotion`].type
            //     let cashType = array[0][`Promotion`].cashType
            //     let disAmount
            //     let total = { subTotal: 0 }
            //     array.reduce((acc, o) => {
            //         acc.subTotal += (o.qty * o.price)
            //         return acc
            //     }, total)
            //     let isPriceLimit = total.subTotal >= priceLimit ? true : false

            //     if (isPriceLimit) {
            //         if (type === 'Discount') {
            //             state.promotionType = array[0][`Promotion`].type
            //             state.isPromotion = true
            //             state.code = ''
            //             state.useCode = false
            //             if (cashType === 'USD') {
            //                 disAmount = array[0][`Promotion`].amount / total.subTotal * 100
            //             } else {
            //                 disAmount = array[0][`Promotion`].amount
            //             }
            //             array.map(res => {
            //                 let index
            //                 if (res.variants.length > 0) {
            //                     index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
            //                 } else {
            //                     index = state.data.findIndex(e => e.productId === res.productId)
            //                 }
            //                 // state.data[index].discount = state.data[index].price * state.data[index].qty * disAmount / 100
            //                 // state.data[index].total = state.data[index].total - state.data[index].discount
            //                 state.data[index].discount = array[0][`Promotion`].amount
            //                 state.data[index].prefix = cashType === 'USD' ? false : true
            //                 let discount = state.data[index].price * state.data[index].qty * disAmount / 100
            //                 state.data[index].total = state.data[index].total - discount

            //                 if (cashType === 'USD') {
            //                     state.data[index].discount = discount
            //                 }
            //             })
            //         } else if (type === 'Coupon') {
            //             let promCode = array[0][`Promotion`].couponCode
            //             if (code === promCode) {
            //                 state.promotionType = array[0][`Promotion`].type
            //                 state.isPromotion = true
            //                 state.code = code
            //                 state.useCode = true
            //                 if (cashType === 'USD') {
            //                     disAmount = array[0][`Promotion`].amount / total.subTotal * 100
            //                 } else {
            //                     disAmount = array[0][`Promotion`].amount
            //                 }
            //                 array.map(res => {
            //                     let index
            //                     if (res.variants.length > 0) {
            //                         index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
            //                     } else {
            //                         index = state.data.findIndex(e => e.productId === res.productId)
            //                     }
            //                     // state.data[index].discount = state.data[index].price * state.data[index].qty * disAmount / 100
            //                     // state.data[index].total = state.data[index].price * state.data[index].qty - state.data[index].discount

            //                     state.data[index].discount = array[0][`Promotion`].amount
            //                     state.data[index].prefix = cashType === 'USD' ? false : true
            //                     let discount = state.data[index].price * state.data[index].qty * disAmount / 100
            //                     state.data[index].total = state.data[index].total - discount
            //                 })
            //             } else {
            //                 state.promotionType = 'none'
            //                 state.isPromotion = false
            //                 state.code = code
            //                 state.useCode = false
            //                 array.map(res => {
            //                     let index
            //                     if (res.variants.length > 0) {
            //                         index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
            //                     } else {
            //                         index = state.data.findIndex(e => e.productId === res.productId)
            //                     }
            //                     state.data[index].discount = 0
            //                     state.data[index].total = state.data[index].qty * state.data[index].price
            //                 })
            //             }
            //         } else if (type === 'Gift Card') {
            //             let promCode = array[0][`Promotion`].codeName
            //             // setPromotionCode(code)
            //             if (code === promCode) {
            //                 state.promotionType = array[0][`Promotion`].type
            //                 state.isPromotion = true
            //                 state.code = code
            //                 state.useCode = true
            //                 if (cashType === 'USD') {
            //                     disAmount = array[0][`Promotion`].amount / total.subTotal * 100
            //                     console.log("disAmount: ", disAmount)
            //                 } else {
            //                     disAmount = array[0][`Promotion`].amount
            //                 }
            //                 array.map(res => {
            //                     let index
            //                     if (res.variants.length > 0) {
            //                         index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
            //                     } else {
            //                         index = state.data.findIndex(e => e.productId === res.productId)
            //                     }
            //                     // state.data[index].discount = state.data[index].price * state.data[index].qty * disAmount / 100
            //                     // state.data[index].total = state.data[index].price * state.data[index].qty - state.data[index].discount

            //                     state.data[index].discount = array[0][`Promotion`].amount
            //                     state.data[index].prefix = cashType === 'USD' ? false : true
            //                     let discount = state.data[index].price * state.data[index].qty * disAmount / 100
            //                     state.data[index].total = state.data[index].total - discount
            //                 })
            //             } else {
            //                 state.promotionType = 'none'
            //                 state.isPromotion = false
            //                 state.code = code
            //                 state.useCode = false
            //                 array.map(res => {
            //                     let index
            //                     if (res.variants.length > 0) {
            //                         index = state.data.findIndex(e => e.productId === res.productId && JSON.stringify(e.variants) === JSON.stringify(res.variants))
            //                     } else {
            //                         index = state.data.findIndex(e => e.productId === res.productId)
            //                     }
            //                     state.data[index].discount = 0
            //                     state.data[index].total = state.data[index].qty * state.data[index].price
            //                 })
            //             }
            //         }
            //     } else {
            //         state.promotionType = 'none'
            //         state.isPromotion = false
            //         state.code = code
            //         state.useCode = false
            //         state.data.map(res => (
            //             res.discount = 0,
            //             res.total = res.qty * res.price
            //         ))
            //     }
            // }
        },
        sumupOrder: (state, action) => {
            const { currencyPrice, taxValue, taxStatus } = action.payload
            let total = 0
            for(let i=0; i<state.data.length; i++) {
                total += state.data[i].total
            }
            state.subTotal = total
            state.vat = taxStatus === true ? (total*taxValue/100) : 0 
            let discountValue = state.totalDiscountStatus === true ? (total*state.totalDiscount/100) : state.totalDiscount
            state.grandTotal = taxStatus === true ? ((total-discountValue)+(total*taxValue/100)) : (total-discountValue)
            state.grandTotalRiel = taxStatus === true ? (((total-discountValue)+(total*taxValue/100)) * currencyPrice) : ((total-discountValue) * currencyPrice)
        },
        changeTotalDiscount: (state, action) => {
            const { discount, discountStatus, taxStatus, taxValue, currencyPrice } = action.payload
            state.totalDiscount = discount
            state.totalDiscountStatus = discountStatus
            let discountValue = discountStatus === true ? (state.subTotal*discount/100) : discount
            state.grandTotal = taxStatus === true ? ((state.subTotal-discountValue)+(state.subTotal*taxValue/100)) : (state.subTotal-discountValue)
            state.grandTotalRiel = taxStatus === true ? (((state.subTotal-discountValue)+(state.subTotal*taxValue/100)) * currencyPrice) : ((state.subTotal-discountValue) * currencyPrice)
        },
        returnStock: (state, action) => {
            const { record } = action.payload
            console.log('record: ', record)
            state.receiptId = record._id
            state.data = record.newRecord
            state.oldData.push(record)
            state.client = record.customerId.length > 0 ? record.customerId[0] : null
            state.userId = record.preSaleId.length > 0 ? record.preSaleId[0] : null
            state.numClient = record.numClient
            state.code = ""
            state.subTotal = record.subtotal
            state.vat = record.vat
            state.grandTotal = record.totalPay
            state.grandTotalRiel = record.totalPayRiel
            state.isPromotion = record.isPromotion
            state.isStorePromotion = record.isStorePromotion
            state.promotionType = record.promotionType
            state.code = record.promotionCode
            state.useCode = record.useCode
            state.totalDiscount = record.totalDiscount
            state.totalDiscountStatus = record.totalDiscountStatus === 'cash' ? false : true
            if (state.client !== null) {
                state.client.eWallet = record.eWallet[0]?.balance ? record.eWallet[0]?.balance : 0
            }
        }
    },
})

export const { 
    addProduct, 
    removeProduct, 
    changeQty, 
    changeDiscount, 
    changeDiscountPrefix, 
    changeRemark, 
    checkPromo, 
    clearData, 
    clearClient, 
    changeNumClient, 
    changeClient, 
    changePreSale, 
    retrieveItem, 
    changePromoCode, 
    sumupOrder,
    changeTotalDiscount,
    returnStock 
} = orderList.actions

export default orderList.reducer